import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_ALL_POST_TAGS_WITH_COUNT = gql`
  query GetAllPostTagsWithCount {
    getAllPostTagsWithCount {
      tags {
        tag
        count
      }
    }
  }
`;

const getAllPostTagsWithCount = async () => {
  try {
    const result = await client
      .query({
        query: GET_ALL_POST_TAGS_WITH_COUNT,
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        fetchResults: true,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getAllPostTagsWithCount: tagsData },
    } = result;

    if (tagsData) {
      return tagsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getAllPostTagsWithCount = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getAllPostTagsWithCount Error: ${error}`);
    return null;
  }
};

export default getAllPostTagsWithCount;
